import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class' ;
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_FUNCTIONALITIES } from '../../../../store/authorization';
import { PROFILE_NOTIFICATION_MODULE_NAMESPACE, PROFILE_NOTIFICATION_LOADERS } from '../../../../store/profile-notification/profile-notification-types.store';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { IUserDetails } from '../../../../models/user';
import { UserTemplate } from '../../../../common/enums';

const AuthorizationStore= namespace(AUTHORIZATION_MODULE_NAMESPACE)
const ProfileNotificationStore= namespace(PROFILE_NOTIFICATION_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE);

@Component({
  components: {
    'notification-subsection-loader' :  async () => import('../../loaders/profile-notif-sidebar-loader/ProfileNotifSidebarLoader.vue')
  }
})
class ProfileSidebar extends Vue {

  pannelSidebar: number;

  constructor() {
    super();
    this.pannelSidebar = -1;
  }

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>;

  @ProfileNotificationStore.Getter profileNotificationsTitles : string[]
  @ProfileNotificationStore.Getter loaders: Map<string,boolean>
  @ProfileNotificationStore.Getter profileNotifications: any[]
  @UserStore.Getter userInfo: IUserDetails;
  mounted() {
    switch (this.$route.hash) {
      case '#profile-account':
      case '#global-notifications':
        this.pannelSidebar = 0;
        break;
      case '#notification-parameter-ticket':
      case '#notification-parameter-intervention':
        this.pannelSidebar = 1;
        break;
      case '#team-management':
      case "#other-users":
        this.pannelSidebar= 2;
        break;
      default:
        this.pannelSidebar = -1
        break;
    }

    this.loadAuths()
  }

  get lblSetting() {
    return {
      ...require('../../../../locales/profile').default
    };
  }

  get notificationDetails(): string[] {
    return this.profileNotificationsTitles
  }

  get pannelActive() {
    return this.pannelSidebar
  }

  set pannelActive(value) {
    this.pannelSidebar = value;
  }

  get coLoader(): boolean{
    return this.loaders.get(PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_SIDEBAR)
  }

  get displayManageAgency() {
    return JSON.parse(localStorage.getItem('modules')).agency_management
  }

  get isServiceBookAgency():boolean {
    return this.userInfo.template === UserTemplate.serviceBookAgency
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }
  onNavBarOptionClick(event: Event, hash: string){
    if(this.$route.path !== '/profile' ){
      event.preventDefault()
      this.$router.push(`/profile${hash}`)
      setTimeout(()=>  (event.target as HTMLAnchorElement).click() ,300)
    }
  }

  activeAnchor(anchor) {
    if(anchor === undefined && this.$route.path === '/profile' && !this.$route.hash){
      return 'white'
    }

    if (this.$route.path === `/profile/${anchor}` || this.$route.hash === anchor ) {
      return 'white'
    }
    return ''
  }

  activeAnchorTxt(anchor) {
    if(anchor === undefined && this.$route.path === '/profile' && !this.$route.hash ){
      return 'primary--text router-link-selected'
    }

    if (this.$route.path === `/profile/${anchor}` || this.$route.hash === anchor ) {
      return 'primary--text router-link-selected'
    }
    return 'white--text'
  }

  notificationHash(notification: string){
    const notif= this.profileNotifications.find(notif=> notif.section_notification_name === notification)
    return `#notification-parameter-${notif.section_notification_key}`
  }

  @Watch('pannelSidebar')
  onPannelSideBarChange(newValue: number){
     this.$emit('sidebar-value',newValue)
  }

  redirectTo(path: string | undefined) {
    if (!path) {
      if(!this.$route.hash && window.scrollTo) window.scrollTo(0,0)
      return {
        path: '/profile'
      }
    }
    return {
      path: `/profile/${path}`
    }
  }

  @Watch('$route.path')
  onChangeRoute(newValue?: any){
    this.loadAuths()
  }

  loadAuths(): any {
    this.storeGetFunctionalities('profile')
     .then( response => {
        if(this.$route.meta) Object.keys(response).forEach( key => this.$route.meta[key] = true )
        this.$forceUpdate()
        // this.$emit('can-view-add-member',this.$route.meta['add_team_account'])
     })
    this.storeGetFunctionalities('agency_management')
      .then(response => {
        if (this.$route.meta) Object.keys(response).forEach(key => this.$route.meta[key] = true)
        // this.$forceUpdate()
      })
  }
}

export default ProfileSidebar;



// WEBPACK FOOTER //
// ./src/containers/profile/components/profile-sidebar/index.ts